import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import {institutionOptions} from '../services/institutions';
import Select from 'react-select';


import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';

class ReferPeopleBody extends Component {
    // thecourse = decodeURI(window.location.href.split('/')[4]);
    
    state = {  myform:{course:decodeURI(window.location.href.split('/')[4])} } 

    handleSubmit = (e)=>{
      e.preventDefault();
      const baseURL = `https://courses.`+process.env.REACT_APP_BACKEND+`/course/refer` ; //"https://localhost:8001/auth/login/" ; //
      
     //const {course,info, more} = this.state.myform;
      // const { groupingmap} = this.state
      var data = {...this.state.myform};
  
      console.log("see me",baseURL,data);
      axios.post(baseURL,data,{headers: {
        
      }}
        ).then((response) => {
        console.log(response);
        
       
       
         toast('Successful'); //response.data.coupon
         window.location.href = '/coupon/'+data.course+'/'+response.data.coupon
        // window.location.href = '/'
    
      }).catch((e)=>{
        console.log(e.response);
        // window.location.href = '/'
        if(e.response.data['error']){
          toast(e.response.data['error']);
        }else{
          for (let a in e.response.data){
            toast(e.response.data[a.toString()][0]);
            console.log(e.response.data[a.toString()][0]);
           }
        }
        
         
      });
  
      // console.log(name,password);
    }
    handleinput= (e)=>{
      const myform = {...this.state.myform};
      myform[e.target.name] = e.target.value;
      this.setState({myform},()=>{console.log(this.state.myform)});
      
    }
    handleInstitutionChangea = (selectedOption) => {
      const myform = {...this.state.myform};
      selectedOption = selectedOption.label;
      // selectedOption.map((value)=>value.label)
      myform['institutiona'] = selectedOption;
      this.setState({myform}, () =>{
        // console.log(`New form details:`, this.state.myform,selectedOption)
      }
      );
    };
    handleInstitutionChangeb = (selectedOption) => {
      const myform = {...this.state.myform};
      selectedOption = selectedOption.label;
      // selectedOption.map((value)=>value.label)
      myform['institutionb'] = selectedOption;
      this.setState({myform}, () =>{
        // console.log(`New form details:`, this.state.myform,selectedOption)
      }
      );
    };
  

    render() { 
      
        return (
            <React.Fragment>
             <div>
       
        <ToastContainer />
      </div>
                <section className="showcase mt-2">
    <section className="p-5">
        <div className="container shadow-lg rounded bg-white px-5">
            <p className="pere text-secondary fs-3 text-warning pt-4 px-3 fw-bold">Refer for Licence</p>
            <p className="pere text-secondary fs-3 text-success pt-4 px-3 fw-bold">Varsity Reghub needs your referral:</p>
            <p className="pere text-secondary fs-3 text-success pt-4 px-3 fw-bold">To proceed, you have to refer 2(two) people you think will benefit from using VarsityReghub.
               {/* for managing/teaching their courses. */}
               </p>

            <form onSubmit={this.handleSubmit} className="row g-3 text-secondary">
                <div className="col-md-5 p-4">
                  <p>1.</p>
                <div className='row'>
                <div class="col-md-8">
                  <label for="inputinstitution" class="form-label fw-bold">Institution</label>
                  <Select
                      isMulti={false}
                      isSearchable={true}
                      value={{'label':this.state.myform.institutiona,'value':this.state.myform.institutiona}}
                      onChange={this.handleInstitutionChangea}
                      options={institutionOptions}
                    />
               </div>
               <div class="col-md-4">
                  <label for="title" className="form-label fw-bold" >Title</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='titlea' id="title"/>
                  </div>
                  <label for="name" className="form-label fw-bold">Name</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='namea' id="name"/>
                  <label for="email" className="form-label fw-bold"> Email</label>
                  <input type="email" className="form-control mb-3" onChange={this.handleinput} name='emaila' id="email"/>
                  {/* <label for="institution" className="form-label fw-bold">Institution</label> */}
                 </div>
                  <hr/>
                  <p>2.</p>
                  <div className='row'>
                <div class="col-md-8">
                  <label for="inputinstitution" class="form-label fw-bold">Institution</label>
                  <Select
                      isMulti={false}
                      isSearchable={true}
                      value={{'label':this.state.myform.institutionb,'value':this.state.myform.institutionb}}
                      onChange={this.handleInstitutionChangeb}
                      options={institutionOptions}
                    />
               </div>
               <div class="col-md-4">
                  <label for="title" className="form-label fw-bold" >Title</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='titleb' id="title"/>
                  </div>
                  <label for="name" className="form-label fw-bold">Name</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='nameb' id="name"/>
                  <label for="email" className="form-label fw-bold"> Email</label>
                  <input type="email" className="form-control mb-3" onChange={this.handleinput} name='emailb' id="email"/>
                  {/* <label for="institution" className="form-label fw-bold">Institution</label> */}
                 </div>
                  {/* <div className="form-check">
                    <input className="form-check-input" type="checkbox" onChange={this.handleinput} name="rememberme" id="gridCheck"/>
                    <label className="form-check-label mb-2" for="gridCheck">
                      Remember Me
                    </label>
                  </div> */}
                  <p>We will mention your name in our referral email.
                  How do they address you?</p>
                  <div class="col-md-4">
                  <label for="title" className="form-label fw-bold" >Title</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='referrertitle' id="title"/>
                  </div>
                  <div class="col-md-8">
                  <label for="name" className="form-label fw-bold">Name</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='referrername' id="name"/>
                  </div>

                  <a className="pass text-info text-decoration-none mb-3" href="/">Go back Home</a>
                 
                  <div className="course mt-5">
                      <button type='submit'  className="btn btn-info btn-lg px-5 text-white fw-bold">Refer</button>
                  </div>
                </div>
                <div className="col-md-2">
                </div>
                <div className="col-md-5">
                <img className="recruit img-fluid w-75 d-none d-sm-block mb-2" src="/images/casual-life-3d-recruiter-woman-having-online-interview.png"/>
                </div>
              </form>
              </div>
              </section>
              </section>
              
            </React.Fragment>
        );
    }
}
 
export default ReferPeopleBody;